import { styled } from '@olxeu-jobs/ui';

export const Wrapper = styled('aside', () => ({
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
}));
